import { API_ENDPOINTS } from './api-endpoints';
import { crudFactory } from './curd-factory';
import { HttpClientFront } from './http-client-front';


export const getStockStat = {
    ...crudFactory(API_ENDPOINTS),
  get:({
    id,   
    ...params 
  }) => {    
    return HttpClientFront.get(`get_stock_stat_count/${id}`, {
      ...params,      
    });
  }
}

export const getFaqsData = {
    ...crudFactory(API_ENDPOINTS),
  get:({
    id,   
    ...params 
  }) => {    
    return HttpClientFront.get(`get_faqs_data/${id}`, {
      ...params,      
    });
  }
}

export const increaseStockView = (id) => {
  return HttpClientFront.post(`/increase_stock_view/${id}`);
};